import { render, staticRenderFns } from "./Logout-SSO.vue?vue&type=template&id=1d664b60&scoped=true"
import script from "./Logout-SSO.vue?vue&type=script&lang=js"
export * from "./Logout-SSO.vue?vue&type=script&lang=js"
import style0 from "./Logout-SSO.vue?vue&type=style&index=0&id=1d664b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d664b60",
  null
  
)

export default component.exports